<template>
  <div v-if="show">
    <section class="announcements" resmed-component-name="announcements">
      <div class="component">
        <div class="col-12 headline-text" style="padding:0px;">
          <div class="row">
            <div style="overflow: hidden" class="swiper-wrapper">
              <div class="swiper">
                <div class="row">
                  <div class="col-12" style="padding: 0px">
                    <div class="seek">
                      <div
                        ref="swiperContainer"
                        class="swiper-container"
                        v-bind:class="`-mode-${[$root.mode]}`"
                      >
                        <div
                          class="items swiper-wrapper"
                          :class="
                            ($root.mode === 'lg' ||
                              $root.mode === 'xl' ||
                              $root.mode === 'md') &&
                            acf.announcement_items.length < 1
                              ? 'center-mode'
                              : ''
                          "
                        >
                          <div
                            class="item swiper-slide"
                            v-for="(item, index) in renderedTemplate"
                            :key="index"
                            style="width:100% !important"
                          >
                            <div
                              style="width: inherit"
                              v-html="renderedTemplate[index]"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  v-show="
                    ['xs', 'sm', 'lg', 'xl', 'md'].includes($root.mode) &&
                      items_length > 1
                  "
                >
                  <div class="col">
                    <div
                      ref="swiperPagination"
                      class="swiper-pagination aswp"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //container end -->
      </div>
    </section>
  </div>
</template>

<script>
import helper from "../../mixins/swiper-helper";
import scrollTarget from "../../mixins/scroll-target";
var pug = require("pug");

export default {
  name: "announcements", // announcements
  props: ["acf"],
  data() {
    return {
      slider: undefined,
      announcement_items: this.acf.announcement_items,
      items_length: this.acf.announcement_items.length,
      key: "",
      renderedData: [],
      filteredTemplate: [],
    };
  },
  mixins: [helper, scrollTarget],
  methods: {
    isResmedUser() {
      const email = this.$cookies.get("rocEmail");
      if (email && email.toLowerCase().includes("@resmed.")) {
        return true;
      }
      return false;
    },
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        autoplay: {
          delay: 30000,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
          992: {
            slidesPerView: 1,
            slidesPerGroup: 1,
          },
        },
        // loop: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
  computed: {
    show() {
      const role = this.$cookies.get("role");
      const b2bFirstName = this.$cookies.get("b2bFirstName");

      const roles = (role && role.split(",").map((r) => r.trim())) || [];
      const hasAnyTechnicalRole = roles.some(
        (r) =>
          r.includes("sleep_approved") ||
          r.includes("ventilator_approved") ||
          r.includes("oxygen_approved")
      );

      if (hasAnyTechnicalRole && b2bFirstName) {
        return true;
      }
      return false;
    },
    renderedTemplate() {
      for (let item of this.announcement_items) {
        let compiledTemplate = pug.compile(
          item.announcement_description.replaceAll(/<\/?[^>]+(>|$)/g, "")
        );
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.renderedData.push(
          compiledTemplate({ isInternalUser: this.isResmedUser() })
        );
      }

      this.renderedData &&
        this.renderedData.filter((item) => {
          if (this.isResmedUser() && !item.includes("onlyExternalUsers")) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.filteredTemplate.push(item);
          } else if (
            !this.isResmedUser() &&
            !item.includes("onlyInternalUsers")
          ) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.filteredTemplate.push(item);
          } else if (
            !item.includes("onlyInternalUsers") &&
            !item.includes("onlyExternalUsers")
          ) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.filteredTemplate.push(item);
          }
        });
      return this.filteredTemplate;
    },
  },
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.announcements {
  // padding: 0 4rem;
  @media (width: 768px) {
    padding: 0 1rem;
  }

  @media (max-width: 767px) {
    padding: 0;
  }
}

h2 {
  position: relative;
  margin-bottom: 0.5rem;

  @extend %eyebrow-center;
}

h4 {
  position: relative;
  margin-bottom: 0.625rem;

  @extend %eyebrow-left;
}

p {
  margin: 0 auto 1.5rem auto;
}

.swiper {
  padding: 0 3.5rem;

  @media (min-width: 768px) {
    padding: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  @media (max-width: 768px) {
    width: 100%;
    padding: 0px;
  }
}

.seek-wrapper {
  position: absolute;
  z-index: 1;

  width: 100%;
  bottom: -42px;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: 992px) {
    width: 20%;
  }

  @media (min-width: 768px) and (max-width: 991px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  @media (min-width: 1306px) {
    width: 100%;
    bottom: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  a:nth-child(1) {
    float: left;
    transform: translateX(-3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(-4rem) scale(1.4);
    }
  }

  a:nth-child(2) {
    float: right;
    transform: translateX(3rem) scale(1.175);

    @media (min-width: 992px) {
      transform: translateX(4rem) scale(1.4);
    }
  }
}

.-mode-xs,
.-mode-sm {
  &.swiper-container {
    overflow: visible;
  }
}

.-mode-md,
.-mode-lg,
.-mode-xl {
  &.swiper-container {
    overflow: hidden;
  }
}

.swiper-container {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 1rem 0 0 0;

  @media (min-width: 768px) {
    padding: 1rem 0 0 0;
  }
}

.items {
  display: flex;
  align-items: stretch;
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  &.center-mode {
    @media (min-width: 768px) {
      justify-content: center;
    }
  }
}

.item {
  padding: 0 0.625rem;
  display: flex;
  flex-shrink: 0;
  align-items: stretch;
  width: 100%;

  .wrapper {
    // padding: 4rem 2rem 3rem 2rem;
    position: relative;
    box-shadow: -1px 0.25rem 12px 2px rgba(0, 0, 0, 0.125);
    // box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    background-color: $cc-resmed-white;
    // background-size: 100%;
    color: #fff;

    background-size: cover;
    background-repeat: no-repeat;
    display: grid;
    align-items: center;
    padding: 3rem 2rem 2rem;

    .btn {
      position: absolute;
      bottom: 2rem;
    }

    @media (max-width: 768px) {
      padding: 2rem 1rem 2rem 1rem;
      box-shadow: -0.5px 0.125rem 6px 1px rgba(0, 0, 0, 0.125);
      background-size: cover;
    }
  }
}

.acmntp {
  font-size: 14px;
  text-align: left;
}
.acmntdspan {
  color: #fff;
}
.acmntddspan {
  color: #f2f2f2;
}

.readmorebtn {
  padding: 6px 8px;
  color: #fff;
  background: #2a6cce;
}
.readmorebtn:hover {
  padding: 6px 8px;
  color: #fff;
  background: #2a6cced6;
}

.swiper-pagination {
  padding: 0px !important;
}
.aswp {
  margin-top: -25px !important;
}

.swiper-pagination span[class*="-active"] {
  background-color: #fff !important;
}
</style>
